var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 73,
    viewBox: "0 0 80 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 60.1465H2.20075V71.9919H0V60.1465Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3997 71.9952L16.3842 64.1367L12.4908 70.6361H11.5089L7.61546 64.2364V71.9889H5.51758V60.1436H7.32867L12.0325 67.9989L16.6554 60.1436H18.4633L18.482 71.9889L16.3997 71.9952Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6829 70.1494V71.9948H21.7988V60.1494H30.446V61.9948H23.9996V65.0715H29.7134V66.8826H23.9996V70.1494H30.6829Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0069 71.9948L38.5879 68.5253C38.4357 68.5409 38.2827 68.5472 38.1297 68.5441H35.4552V71.9948H33.2544V60.1494H38.1297C41.2469 60.1494 43.1733 61.7423 43.1733 64.3639C43.2097 65.1754 42.9842 65.9771 42.5301 66.6506C42.0761 67.3242 41.4174 67.8339 40.6515 68.1045L43.376 71.9979L41.0069 71.9948ZM38.0268 62.0197H35.4552V66.7423H38.0268C39.9564 66.7423 40.957 65.8601 40.957 64.3701C40.957 62.8801 39.9564 62.0104 38.0268 62.0104V62.0197Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8343 65.935H55.9166V70.6576C54.582 71.6634 52.9491 72.1935 51.2782 72.1632C47.6061 72.1632 44.9004 69.6102 44.9004 66.0722C44.9004 62.5341 47.6061 59.978 51.3125 59.978C53.295 59.978 54.9534 60.6389 56.0693 61.9076L54.6822 63.2636C54.2612 62.8237 53.7534 62.4761 53.1911 62.2427C52.6287 62.0093 52.0241 61.8952 51.4154 61.9076C48.8935 61.9076 47.1167 63.6158 47.1167 66.0722C47.1167 68.4755 48.8935 70.2336 51.3998 70.2336C52.2509 70.2514 53.0914 70.0415 53.8343 69.6258V65.935Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8149 70.1494V71.9948H58.9277V60.1494H67.578V61.9948H61.1285V65.0715H66.8486V66.8826H61.1285V70.1494H67.8149Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3616 67.8148V71.995H73.1608V67.8491L68.5068 60.1465H70.8603L74.3298 65.9195L77.8335 60.1465H80L75.3616 67.8148Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2862 19.3641L57.4844 21.0443L55.3242 33.6066L43.2419 41.2874L39.2394 53.7718L29.8785 47.2911L36.9202 39.2082L16.116 17.7618L15.7139 0L46.5212 19.9221L54.6041 12.2413L64.2862 19.3641Z",
    fill: "#1563A3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.167 11.0912L45.8827 16.964L51.4033 11.6804L51.8023 1.83936L43.4825 3.60058L37.167 11.0912Z",
    fill: "#1A2753"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.f662a484a1a1b64d3c2b8865842c35f5.svg";
export { ForwardRef as ReactComponent };